import { SourceName } from 'features/application/hooks/useApplicationTrackErrorEvents';
import Employment from 'features/application/screens/Employment/Employment';
import useCustomerApplicationOrigination from 'features/signup/hooks/useCustomerApplicationOrigination';
import React from 'react';
import { useTranslation } from 'react-i18next';

const EmploymentWrapper = () => {
  const {
    application,
    error,
    fetching,
    reExecuteQuery,
    hasApplicationLoaded,
    isReapplication,
  } = useCustomerApplicationOrigination({
    sourceName: SourceName.EMPLOYMENT,
  });

  const { t } = useTranslation('signup', {
    keyPrefix: 'employment',
  });

  return (
    <Employment
      applicationId={application?.id}
      nextRoute="/signup/citizenship"
      sourceName={SourceName.EMPLOYMENT}
      error={error}
      isReapplication={isReapplication}
      hasApplicationLoaded={hasApplicationLoaded}
      onRetry={reExecuteQuery}
      backRoute="/signup/dob"
      title={t('title')}
      description={t('description')}
      analyticsStepName="personal_info_employment"
      applicationDataLoading={fetching}
    />
  );
};

export default EmploymentWrapper;
